<template>
	<div style="width: 100%;height: 100%;background: #eceef1;">
		<Layout-Top menuName="实名认证" prevUrl="/WeChat/Person/Account">
		</Layout-Top>
		<!-- <Row type="flex" justify="center" align="center" style="height: 46px;width: 100%; background: #eceef1;line-height: 46px;">
			<Col span="2">
				<Icon style="margin-top: -2px;" size="28" type="ios-arrow-back" />
			</Col>
			<Col span="22">
				实名认证 
			</Col>
		</Row> -->
		<div style="width: 100%;height: 210px;padding-top: 28px;">
			<div style="width: 166px;height: 166px;position: relative;margin: 0 auto;">
				<img style="height: 166px;"  src="../../../../../../assets/image/idcard.png" />
				<div style="position: absolute; bottom: 25px;right: -6px;height: 46px;width: 46px;background: white;background: white;border-radius: 36px;" >
					<Icon style="margin-top: -8px;margin-left: -8px;" size="73" :color="binding?'#19be6b':'#ff9900'" :type="binding?'ios-checkmark-circle':'md-information-circle'" />
				</div>
			</div>
		</div>
		<div style="height: 28px;line-height:28px;width: 100%;font-size: 16px;margin-bottom: 26px;font-weight:600">
			<Row v-if="binding" type="flex" justify="center" align="center" style="height: 28px;">
				<Col span="10" style="text-align: right;">
					姓名:
				</Col>
				<Col span="12">
					王**
				</Col>
			</Row>
			<Row v-if="binding" type="flex" justify="center" align="center" style="height: 28px;">
				<Col span="10" style="text-align: right;">
					身份证:
				</Col>
				<Col span="12">
					5115******518
				</Col>
			</Row>
			<div v-if="!binding" style="color: #CCCCCC;text-align: center;width: 100%;">
				还未实名认证
			</div>
		</div>
		<Row v-if="!binding" type="flex" justify="center" align="center" style="height: 36px;">
			<Col span="2">
			</Col>
			<Col span="20">
				<Button @click="toPage('/WeChat/Person/Account/IdCard/Binding')" size="large" long>立即认证</Button>
			</Col>
			<Col span="2">
			</Col>
		</Row>
	</div>
</template>
<script>
	import Top from '../../assembly'
	export default {
		components: {
			'Layout-Top': Top
		},
		data(){
			return {
				person:{
					pno:'5115*************8'
				},
				binding:false	
			}
		},
		methods:{
			toPage(page){
				this.$router.push(page);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Account/IdCard/index.vue